<template>
  <div v-if="showComponent" class="modal-body">
    <div slot="body" id="modal-chart">
      <div class="modal-header-stock-chart" id="modal-header-stock-chart">
        <div class="modal-h-left">
          <div class="chart-title text-center">{{title}}</div>
          <div class="button-group">
            <time-toggle slot="toggle" :select="toggleQorY" :select-function="toggleTimeData" />
          </div>
        </div>
        <div class="modal-h-right">
          <!-- <div id="saveButton" class="action-button" v-on:click="saveChart">
            <i class="fas fa-download"></i>บันทึกรูปภาพ
          </div>-->
        </div>
      </div>
      <div class="chart-wraper" id="chart-wraper-for-create">
        <div id="stockchart"></div>
      </div>
      <div class="chart-wraper">
        <div id="stockchartimg"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import * as d3 from "d3";
import TimeToggle from "../../components/miniapp/stock-quote/TimeToggle";
import moment from "moment";
import { async } from "q";
import { log } from "util";
const { obj } = require("../miniapp/stock/data");

const FormData = require("form-data");
const FileSaver = require("file-saver");
const asset = require("../../assets/json/chart-asset.json");
var configStock = require("../../assets/json/config-financial-card.json");

export default {
  components: {
    TimeToggle
  },
  data: function() {
    return {
      toggleQorY: 1,
      margin: { top: 50, right: 50, bottom: 50, left: 50 },
      width: 0, // Use the window's width
      height: 0,
      currentData: null,
      dotSize: 4,
      title: "กราฟหุ้น",
      sharingModal: false,
      renderComponent: true,
      SharingPath: process.env.baseUrl,
      dataChart: this.getChartData,
      startYear: null,
      cardData: null,
      ID: null,
      isCalculateSize: 0,
      showComponent: false
    };
  },
  props: {
    maxWidth: {
      type: Number,
      default: 960
    },
    closeFunction: {
      type: Function,
      default: () => {}
    },
    wrapperClickClose: {
      type: Boolean,
      default: true
    },
    escPressClose: {
      type: Boolean,
      default: true
    }
  },
  async created() {
    this.showComponent = true;
    this.$store.commit("global/SET_SHOW_FOOTER", false);
    await this.findStockQuote(this.$route.query.stock_name);
    let currentDate = new Date();
    currentDate.setYear(currentDate.getFullYear() - 10);
    this.startYear = currentDate.getFullYear();
    this.ID = this.getStockQuote.ID;
    await this.findStockBySecurityID({
      securityID: this.getStockQuote.ID,
      fiscal: this.startYear
    });
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.updateResponsive();
    });
  },
  computed: {
    ...mapGetters("stock", [
      "getChartData",
      "showChartModal",
      "getStockQuote",
      "getStocks",
      "getFinancialCardByCardName"
    ]),
    getStock() {
      return this.findStockQuote(this.$route.query.stock_name);
    },
    getStockBySecurityID() {
      let currentDate = new Date();
      currentDate.setYear(currentDate.getFullYear() - 10);
      this.startYear = currentDate.getFullYear();
      this.ID = this.getStockQuote.ID;
      this.findStockBySecurityID({
        securityID: this.ID,
        fiscal: this.startYear
      });
    },
    getData() {
      this.ID = this.getStockQuote.ID;
      let res = this.$store.getters["stock/getFinancialCardByCardName"]({
        securityID: this.ID,
        fields: obj[`${this.$route.query.graph_name}`]
      });
      return res;
    }
  },
  watch: {
    showChartModal() {
      return this.showChartModal;
    },
    getChartData() {
      this.currentData = this.getStockData();
      return this.getChartData;
    },
    currentData() {
      this.calculateChartSize();
    },
    $route: async function(newRoute, oldRoute) {
      this.showComponent = false;
      if (newRoute.query.stock_name && newRoute.query.topic) {
        window.location.reload();
        // await this.findStockQuote(newRoute.query.stock_name);
        // let currentDate = new Date();
        // currentDate.setYear(currentDate.getFullYear() - 10);
        // this.startYear = currentDate.getFullYear();
        // this.ID = this.getStockQuote.ID;
        // await this.findStockBySecurityID({
        //   securityID: this.getStockQuote.ID,
        //   fiscal: this.startYear
        // });
        // this.showStockChartModal({
        //   data: this.getData,
        //   topic: this.$route.query.topic,
        //   stock: this.$route.query.stock_name,
        //   name: this.getDataName(this.$route.query.topic),
        //   timeframe: 1,
        //   sectionID: ""
        // });
      } else {
        this.$store.commit("global/SET_SHOW_FOOTER", true);
      }
    },
    getData() {
      this.showStockChartModal({
        data: this.getData,
        topic: this.$route.query.topic,
        stock: this.$route.query.stock_name,
        name: this.getDataName(this.$route.query.topic),
        timeframe: 1,
        sectionID: ""
      });
    },
    isCalculateSize() {
      if (this.currentData.length) {
        d3.select("#stockchart").remove();
        d3.select("#chart-wraper-for-create")
          .append("div")
          .attr("id", "stockchart");
        this.drawChart(
          "#stockchart",
          this.width,
          this.height,
          this.margin,
          this.currentData
        );
      }
    }
  },
  methods: {
    ...mapActions("stock", [
      "closeChartModal",
      "showStockChartModal",
      "findStockQuote",
      "findStockBySecurityID"
    ]),
    async closeModal() {
      await this.closeChartModal();
      // document.exitFullscreen();
    },
    getDataName(name) {
      let filter_data = configStock.financialCard.find(function(row) {
        return row.name && row.name == name;
      });
      if (filter_data) {
        return filter_data.name_th;
      }
      return "";
    },
    getStockData() {
      let rawdata = [];

      if (this.getChartData && this.getChartData.data) {
        if (this.toggleQorY == 1) {
          rawdata = this.getChartData.data.qoq[this.getChartData.topic];
        } else {
          rawdata = this.getChartData.data.yoy[this.getChartData.topic];
        }
      }

      let data = [];
      for (let key in rawdata) {
        if (rawdata[key]) {
          data.push({ key: key, value: Number(rawdata[key])*1000 });
        }
      }

      let dataname = this.getChartData.name;
      dataname = dataname.replace(/(<([^>]+)>)/gi, "");

      if (dataname.substr(dataname.length - 1) == ")") {
        dataname = dataname + " ";
      }

      let timeframe = this.toggleQorY == 1 ? "quarter" : "year";
      // this.SharingPath = `${this.getSharingUrl}/stock/${this.getChartData.stock}?chart=${this.getChartData.topic}&timeframe=${timeframe}`;
      this.title = `${dataname}ของ ${this.getChartData.stock}`;
      let modalBody = document.getElementsByClassName("modal-body");
      // filter becasue มากเกินไป
     this.currentData = data;

      return data;
    },
    toggleTimeData(index) {
      this.toggleQorY = index;
      this.updateChartData();
    },
    addXAxisStyle(data) {
      let modalBody = document.getElementsByClassName("modal-body");
      d3.select(".x.axis")
        .selectAll(".tick")
        .style("display", (d, i) => {
          let n = data.length;
          let w = modalBody[0].clientWidth;
          let nth = 2;

          if (w <= 320) {
            if (n < 11) {
              nth = 3;
            } else {
              nth = 12;
            }
          } else if (w <= 640) {
            if (n < 11) {
              nth = 2;
            } else {
              nth = 6;
            }
          } else {
            if (n < 11) {
              nth = 1;
            } else {
              nth = 3;
            }
          }

          if (i % nth == 0) {
            return "block";
          }

          return "none";
        });
    },
    updateResponsive() {
      this.calculateChartSize();
      d3.select("#stockchart").remove();
      d3.select("#stockchart")
        .select("svg")
        .attr("width", this.width + this.margin.left + this.margin.right)
        .attr("height", this.height + this.margin.top + this.margin.bottom)
        .select(".x.axis")
        .attr("transform", "translate(0," + this.height + ")");

      this.updateChart(this.currentData, this.width, this.height);
    },
    updateChartData() {
      this.currentData = this.getStockData();
      this.updateChart(this.currentData, this.width, this.height);
    },
    updateChart(data, width, height) {
      let svg = d3.select("#stockchart");
      let xScale = this.getXscale(data, width);
      let yScale = this.getYscale(data, height);
      let valueline = this.getLine(data, xScale, yScale);

      svg
        .transition()
        .select(".x.axis") // change the x axis
        .duration(750)
        .call(d3.axisBottom(xScale));

      svg
        .transition()
        .select(".y.axis") // change the y axis
        .duration(750)
        .call(d3.axisLeft(yScale));

      function make_y_gridlines() {
        return d3.axisLeft(yScale).ticks();
      }

      let grid = d3
        .select("#stockchart")
        .select("svg")
        .select("g")
        .select(".grid");

      // add the Y gridlines
      grid
        .transition()
        .duration(750)
        .call(
          make_y_gridlines()
            .tickSize(-width)
            .tickFormat("")
        );

      svg
        .transition()
        .select(".d3-stock-line") // change the line
        .duration(750)
        .attr("d", valueline(data));

      var circle = d3
        .select("#stockchart")
        .select("svg")
        .select("g")
        .selectAll(".stock-line-dot")
        .data(data);

      this.addXAxisStyle(data);
      this.addChartDot(circle.enter(), data, xScale, yScale);

      circle
        .transition()
        .duration(500)
        .attr("cx", function(d, i) {
          return xScale(d.key);
        })
        .attr("cy", function(d) {
          return yScale(d.value);
        })
        .attr("r", this.dotSize);

      circle.exit().remove();
    },
    addChartDot(svg, data, xScale, yScale) {
      let div = d3.select("#stockchart").select(".tooltipChart");

      // 12. Appends a circle for each datapoint
      svg
        .append("circle") // Uses the enter().append() method
        .attr("class", "stock-line-dot") // Assign a class for styling
        .attr("cx", function(d, i) {
          return xScale(d.key);
        })
        .attr("cy", function(d) {
          return yScale(d.value);
        })
        .attr("r", this.dotSize)
        .on("mouseover", (d, i) => {
          let position = 0;
          let dots = document.getElementsByClassName("stock-line-dot").length;

          if (i / dots > 0.8) {
            position = d3.event.pageX - 120;
          } else {
            position = d3.event.pageX;
          }

          div
            .transition()
            .duration(200)
            .style("opacity", 0.9);
          div
            .html(
              `<b>${d.key}</b><br />${d.value
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            )
            .style("left", xScale(d.key) + "px")
            .style(
              "top",
              yScale(d.value) + 50 + "px"
            );
        })
        .on("mouseout", function(d) {
          div
            .transition()
            .duration(500)
            .style("opacity", 0);
        });
    },
    getXscale(data, width) {
      return d3
        .scalePoint()
        .domain(data.map(d => d.key)) // input
        .range([5, width]); // output
    },
    getYscale(data, height) {
      return d3
        .scaleLinear()
        .domain([d3.min(data, d => d.value), d3.max(data, d => d.value)]) // input
        .range([height, 0]); // output
    },
    getLine(data, xScale, yScale) {
      return d3
        .line()
        .x(function(d, i) {
          return xScale(d.key);
        }) // set the x values for the line generator
        .y(function(d) {
          return yScale(d.value);
        });
    },
    drawChart(selector, width, height, margin, data, option) {
      let xScale = this.getXscale(data, width);
      let yScale = this.getYscale(data, height);
      let line = this.getLine(data, xScale, yScale);

      // 1. Add the SVG to the page and employ #2
      let svgContainer = d3
        .select(selector)
        .append("svg")
        .attr("width", width + margin.left + margin.right + 50)
        .attr("height", height + margin.top + margin.bottom + 50);
      // .attr("height", width + margin.left + margin.right)
      // .attr("width", height + margin.top + margin.bottom);

      svgContainer
        .append("rect")
        .attr("width", "100%")
        .attr("height", "100%")
        .attr("fill", "#ffffff");

      let svg = svgContainer
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      function make_y_gridlines() {
        return d3.axisLeft(yScale).ticks();
      }

      // add the Y gridlines
      svg
        .append("g")
        .attr("id", "innerGraph")
        .attr("class", "grid")
        .style("opacity", 0.3)
        .style("stroke", "lightgrey")
        .call(
          make_y_gridlines()
            .tickSize(-width)
            .tickFormat("")
        );

      // 3. Call the x axis in a group tag
      svg
        .append("g")
        .attr("transform", "translate(0," + height + ")")
        .attr("class", "x axis")
        .call(d3.axisBottom(xScale)); // Create an axis component with d3.axisBottom

      // 4. Call the y axis in a group tag
      svg
        .append("g")
        .attr("class", "y axis")
        .call(d3.axisLeft(yScale)); // Create an axis component with d3.axisLeft

      // 9. Append the path, bind the data, and call the line generator
      svg
        .append("path")
        .datum(data) // 10. Binds data to the line
        .attr("class", "d3-stock-line") // Assign a class for styling
        .attr("d", line); // 11. Calls the line generator
      var el = d3
        .select(selector)
        .node()
        .getBoundingClientRect();
      let widthSvg = el.width / 3;
      let heightSvg = el.height / 3;
      let innerGraph = d3
        .select("#innerGraph")
        .node()
        .getBoundingClientRect();
      let posX = (innerGraph.width - heightSvg) / 2;
      let posY = (innerGraph.height - widthSvg) / 3;
      const img = require("../../assets/imgs/fin-banner_fade.svg");
      svg
        .append("image")
        .attr("xlink:href", img)
        .attr("transform", `translate(${posY}, ${posX})`)
        .attr("width", heightSvg)
        .attr("height", widthSvg)
        .attr("preserveAspectRatio", "xMidYMid slice");

      // Define the div for the tooltip
      let div = d3
        .select("#stockchart")
        .append("div")
        .attr("class", "tooltipChart")
        .style("opacity", 0);

      this.addXAxisStyle(data);
      let circle = svg
        .selectAll(".dot")
        .data(data)
        .enter();
      this.addChartDot(circle, data, xScale, yScale);

      if (option && option.title) {
        svg
          .append("text")
          .attr("x", option.title.x)
          .attr("y", option.title.y)
          .attr("text-anchor", "left")
          .attr("class", "svg-chart-title")
          .style("font-size", option.title.size)
          .style("font-weigh", "bold")
          .style("opacity", option.title.opacity)
          .style("font-family", "DBHeaventRez")
          .text(option.title.text);

        if (option.title.align == "center") {
          const b = document.getElementsByClassName("svg-chart-title")[0];
          const bBox = b.getBBox();
          const x = (width - bBox.width) / 2;
          d3.select(".svg-chart-title").attr("x", x);
        }
      }

      if (option && option.subtitle) {
        svg
          .append("text")
          .attr("x", option.subtitle.x)
          .attr("y", option.subtitle.y)
          .attr("text-anchor", "left")
          .attr("class", "svg-chart-sub-title")
          .style("font-size", option.subtitle.size)
          .style("font-weigh", "bold")
          .style("opacity", option.subtitle.opacity)
          .style("font-family", "DBHeaventRez")
          .text(option.subtitle.text);

        if (option.subtitle.align == "center") {
          const b = document.getElementsByClassName("svg-chart-sub-title")[0];
          const bBox = b.getBBox();
          const x = (width - bBox.width) / 2;
          d3.select(".svg-chart-sub-title").attr("x", x);
        }
      }

      if (option && option.logo) {
        let finlogo =
          '<defs><path id="a" d="M.326.013h18.703v18.534H.326z"/><path id="c" d="M0 .08h30.623v44.557H0z"/></defs><g fill="none" fill-rule="evenodd"><path fill="#797979" d="M39.34 13.36h12.757v2.863h-9.49v4.806h9.295v2.862h-9.295v8.003H39.34zM60.608 31.894h3.266V13.36h-3.266zM76.685 18.39v13.504h-3.266V13.36h3.35l9.518 13.143V13.36h3.266v18.534h-3.154zM102.362 18.39v13.504h-3.266V13.36h3.35l9.518 13.143V13.36h3.266v18.534h-3.154zM133.454 15.945c-3.768 0-6.17 2.862-6.17 6.696 0 3.807 2.402 6.696 6.17 6.696 3.74 0 6.17-2.89 6.17-6.696 0-3.834-2.43-6.696-6.17-6.696m0-2.89c5.583 0 9.519 4.057 9.519 9.586 0 5.53-3.936 9.587-9.52 9.587-5.582 0-9.517-4.058-9.517-9.587 0-5.53 3.935-9.586 9.518-9.586M167.786 17.862l-5.723 14.032h-1.396l-5.694-14.032v14.032h-3.266V13.36h4.606l5.052 12.476 5.08-12.476h4.607v18.534h-3.266zM180.594 13.36h12.757v2.863h-9.491v4.806h9.295v2.862h-9.295v5.14h9.49v2.863h-12.756zM205.546 18.39v13.504h-3.266V13.36h3.35l9.518 13.143V13.36h3.266v18.534h-3.154z"/><g transform="translate(225.677 13.347)"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#797979" d="M6.187 12.128h6.979L9.677 2.764l-3.49 9.364zm7.9 2.862h-8.82l-1.368 3.557H.326L7.64.013h4.075l7.314 18.534h-3.573l-1.368-3.557z" mask="url(#b)"/></g><g transform="translate(0 .283)"><mask id="d" fill="#fff"><use xlink:href="#c"/></mask><path fill="#F7A501" d="M26.889.08L0 1.808l5.685 38.956 5.918 3.873V8.115l19.02-5.941z" mask="url(#d)"/></g><path fill="#F7A501" d="M14.618 29.092l3.698-1.255v-1.934l6.433-2.182v-3.569l-10.131 2.992z"/></g>';

        if (option.logo.size == "small") {
          finlogo =
            '<defs><polygon id="path-1" points="0.237309385 0.00891219512 13.8653182 0.00891219512 13.8653182 12.758344 0.237309385 12.758344"></polygon><polygon id="path-3" points="0.000159392848 0.0551707317 22.3138298 0.0551707317 22.3138298 30.7057326 0.000159392848 30.7057326"></polygon></defs><g id="Chart-Stock" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.335890997"><g id="Group-22"><polygon id="Fill-1" fill="#797979" points="28.5882353 9.52941176 38.1176471 9.52941176 38.1176471 11.4918946 31.0281896 11.4918946 31.0281896 14.7869153 37.9722139 14.7869153 37.9722139 16.7489006 31.0281896 16.7489006 31.0281896 22.2352941 28.5882353 22.2352941"></polygon><polygon id="Fill-2" fill="#797979" points="44.4705882 22.2352941 46.5882353 22.2352941 46.5882353 9.52941176 44.4705882 9.52941176"></polygon><polygon id="Fill-3" fill="#797979" points="56.3576254 12.9776892 56.3576254 22.2352941 54 22.2352941 54 9.52941176 56.4178951 9.52941176 63.2894335 18.5394672 63.2894335 9.52941176 65.6470588 9.52941176 65.6470588 22.2352941 63.3699686 22.2352941"></polygon><polygon id="Fill-4" fill="#797979" points="74.3576254 12.9776892 74.3576254 22.2352941 72 22.2352941 72 9.52941176 74.4178951 9.52941176 81.2894335 18.5394672 81.2894335 9.52941176 83.6470588 9.52941176 83.6470588 22.2352941 81.3699686 22.2352941"></polygon><g id="Group-21"><path d="M97.2414855,10.7739951 C94.4959437,10.7739951 92.7463415,12.7429162 92.7463415,15.3803768 C92.7463415,17.9988646 94.4959437,19.9867584 97.2414855,19.9867584 C99.9673688,19.9867584 101.737161,17.9988646 101.737161,15.3803768 C101.737161,12.7429162 99.9673688,10.7739951 97.2414855,10.7739951 M97.2414855,8.78610129 C101.309722,8.78610129 104.177465,11.576592 104.177465,15.3803768 C104.177465,19.1839119 101.309722,21.9749019 97.2414855,21.9749019 C93.1735143,21.9749019 90.306037,19.1839119 90.306037,15.3803768 C90.306037,11.576592 93.1735143,8.78610129 97.2414855,8.78610129" id="Fill-5" fill="#797979"></path><polygon id="Fill-7" fill="#797979" points="122.257635 12.0929001 118.087653 21.7452818 117.070726 21.7452818 112.921465 12.0929001 112.921465 21.7452818 110.541729 21.7452818 110.541729 8.99609957 113.897746 8.99609957 117.579189 17.5782689 121.280823 8.99609957 124.63737 8.99609957 124.63737 21.7452818 122.257635 21.7452818"></polygon><polygon id="Fill-9" fill="#797979" points="131.590325 8.99604964 140.885585 8.99604964 140.885585 10.9652204 133.970061 10.9652204 133.970061 14.27147 140.742928 14.27147 140.742928 16.2401415 133.970061 16.2401415 133.970061 19.7765604 140.885585 19.7765604 140.885585 21.7452319 131.590325 21.7452319"></polygon><polygon id="Fill-11" fill="#797979" points="149.771577 12.4561532 149.771577 21.7453067 147.391842 21.7453067 147.391842 8.99612453 149.832412 8.99612453 156.768392 18.0368849 156.768392 8.99612453 159.148127 8.99612453 159.148127 21.7453067 156.849682 21.7453067"></polygon><g id="Group-15" transform="translate(164.440288, 8.987088)"><mask id="mask-2" fill="white"><use xlink:href="#path-1"></use></mask><g id="Clip-14"></g><path d="M4.5085064,8.34293802 L9.59340391,8.34293802 L7.05135364,1.9011934 L4.5085064,8.34293802 Z M10.2649791,10.3116095 L3.83772817,10.3116095 L2.84099156,12.758344 L0.237309385,12.758344 L5.56660926,0.00891219512 L8.53609802,0.00891219512 L13.8653979,12.758344 L11.2617157,12.758344 L10.2649791,10.3116095 Z" id="Fill-13" fill="#797979" mask="url(#mask-2)"></path></g><g id="Group-18"><mask id="mask-4" fill="white"><use xlink:href="#path-3"></use></mask><g id="Clip-17"></g><polygon id="Fill-16" fill="#F7A501" mask="url(#mask-4)" points="19.5927283 0.0550209469 0.000159392848 1.24381291 4.14251386 28.0415604 8.45435605 30.7057326 8.45435605 5.58232941 22.3138298 1.49520172"></polygon></g><polygon id="Fill-19" fill="#F7A501" points="10.6512677 19.817901 13.3458038 18.9543917 13.3458038 17.6245524 18.0332818 16.1232095 18.0332818 13.6682367 10.6512677 15.7265294"></polygon></g></g></g>';
        }

        svg
          .append("g")
          .html(finlogo)
          .attr("class", "svg-chart-banner")
          .style("opacity", option.logo.opacity)
          .attr(
            "transform",
            "translate(" + option.logo.x + "," + option.logo.y + ")"
          );

        if (option.logo.align == "center") {
          const b = document.getElementsByClassName("svg-chart-banner")[0];
          const bBox = b.getBBox();
          const x = (width - bBox.width) / 2;
          d3.select(".svg-chart-banner")
            .attr("x", x)
            .attr("transform", "translate(" + x + "," + option.logo.y + ")");
        }
      }
    },
    calculateChartSize() {
      let longest = 0;
      for (let i = 0; i < this.currentData.length; i++) {
        if (this.currentData[i].value) {
          if (("" + this.currentData[i].value).length > 0) {
            longest = ("" + this.currentData[i].value).length;
          }
        }
      }
      this.margin = { top: 40, right: 40, bottom: 50, left: 45 + longest * 4 };
      // if (window.innerHeight > window.innerWidth) {
      //   // alert("Please use Landscape!");
      // }
      let mode = window.innerHeight > window.innerWidth;
      // if true -> vertical
      let widthModalHeaderChart = document.getElementById(
        "modal-header-stock-chart"
      );
      if (mode) {
        this.width =
          Math.min(document.documentElement.clientHeight) -
          widthModalHeaderChart.clientHeight -
          16 -
          this.margin.left -
          this.margin.right;
        this.height =
          Math.max(Math.min(document.documentElement.clientWidth)) -
          widthModalHeaderChart.clientHeight -
          16 -
          this.margin.top -
          this.margin.bottom;
      } else {
        this.height =
          Math.min(document.documentElement.clientHeight) -
          this.margin.left -
          70 -
          this.margin.right;
        this.width =
          Math.max(Math.min(document.documentElement.clientWidth)) -
          this.margin.top -
          16 -
          this.margin.bottom;
      }
      if (this.currentData.length) {
        this.isCalculateSize++;
      }
    },
    closeSharingModal() {
      this.sharingModal = false;
    },
    async openSharingModal() {
      alert("TODO : share in line only");
    },
    createChartImage(option) {
      const height = 315;
      const width = 600;
      const selector = "#stockchartimg";
      // const selector = "#stockchart";
      this.drawChart(
        selector,
        width,
        height,
        this.margin,
        this.currentData,
        option
      );

      let svgContainer = d3.select(selector).select("svg");

      let n = this.currentData.length;
      let nth = 2;

      svgContainer
        .select("g")
        .select(".x.axis")
        .selectAll(".tick")
        .style("display", (d, i) => {
          if (n < 11) {
            nth = 1;
          } else {
            nth = 3;
          }

          if (i % nth == 0) {
            return "block";
          }
          return "none";
        });

      return {
        svg: svgContainer,
        width: width,
        height: height,
        selector: selector
      };
    },
    svgToString(svgNode) {
      svgNode.setAttribute("xlink", "http://www.w3.org/1999/xlink");
      let cssStyleText = getCSSStyles(svgNode);
      appendCSS(cssStyleText, svgNode);

      let serializer = new XMLSerializer();
      let svgString = serializer.serializeToString(svgNode);
      svgString = svgString.replace(/(\w+)?:?xlink=/g, "xmlns:xlink="); // Fix root xlink without namespace
      svgString = svgString.replace(/NS\d+:href/g, "xlink:href"); // Safari NS namespace fix

      return svgString;

      function getCSSStyles(parentElement) {
        let selectorTextArr = [];

        // Add Parent element Id and Classes to the list
        selectorTextArr.push("#" + parentElement.id);
        for (let c = 0; c < parentElement.classList.length; c++)
          if (!contains("." + parentElement.classList[c], selectorTextArr)) {
            selectorTextArr.push("." + parentElement.classList[c]);
          }

        // Add Children element Ids and Classes to the list
        let nodes = parentElement.getElementsByTagName("*");
        for (let i = 0; i < nodes.length; i++) {
          let id = nodes[i].id;
          if (!contains("#" + id, selectorTextArr)) {
            selectorTextArr.push("#" + id);
          }

          let classes = nodes[i].classList;
          for (let c = 0; c < classes.length; c++)
            if (!contains("." + classes[c], selectorTextArr)) {
              selectorTextArr.push("." + classes[c]);
            }
        }

        // Extract CSS Rules
        let extractedCSSText = "";
        for (let i = 0; i < document.styleSheets.length; i++) {
          let s = document.styleSheets[i];

          try {
            if (!s.cssRules) continue;
          } catch (e) {
            if (e.name !== "SecurityError") throw e; // for Firefox
            continue;
          }

          let cssRules = s.cssRules;
          for (let r = 0; r < cssRules.length; r++) {
            if (contains(cssRules[r].selectorText, selectorTextArr))
              extractedCSSText += cssRules[r].cssText;
          }
        }

        return extractedCSSText;

        function contains(str, arr) {
          return arr.indexOf(str) === -1 ? false : true;
        }
      }

      function appendCSS(cssText, element) {
        let styleElement = document.createElement("style");
        styleElement.setAttribute("type", "text/css");

        cssText =
          cssText +
          `@font-face {font-family: DBHeaventRez; src: url('${asset.font}')}`;
        styleElement.innerHTML = cssText;

        let refNode = element.hasChildNodes() ? element.children[0] : null;

        element.insertBefore(styleElement, refNode);
      }
    },
    stringToBase64(str) {
      return `data:image/svg+xml;base64,${btoa(
        unescape(encodeURIComponent(str))
      )}`;
    },
    svgString2Image(imgsrc, width, height, callback) {
      let canvas = document.createElement("canvas");
      let context = canvas.getContext("2d");

      canvas.width = width;
      canvas.height = height;

      let image = new Image();
      image.onload = () => {
        context.clearRect(0, 0, width, height);
        context.drawImage(image, 0, 0, width, height);

        canvas.toBlob(blob => {
          let filesize = Math.round(blob.length / 1024) + " KB";
          if (callback) {
            callback(blob, filesize);
          }
        }, "image/jpeg");
      };
      image.src = imgsrc;
    }
    // saveChart() {
    // push to datalayer
    // dataLayer.clickSaveStockChart({
    //   sectionID: this.getChartData.sectionID,
    //   thName: this.getChartData.name,
    //   enName: this.getChartData.topic
    // });

    //   let option = {};
    //   option.logo = {
    //     x: 355,
    //     y: -40,
    //     opacity: 1,
    //     height: 45,
    //     width: 245
    //   };

    //   option.title = {
    //     text: this.title,
    //     x: 0,
    //     y: -10,
    //     size: 16,
    //     opacity: 1
    //   };

    //   const image = this.createChartImage(option);
    //   const filename = this.title + ".jpg";
    //   const svgString = this.svgToString(image.svg.node());
    //   const imgsrc = this.stringToBase64(svgString);

    //   this.svgString2Image(imgsrc, 2 * image.width, 2 * image.height, save); // passes Blob and filesize String to the callback

    //   d3.select(image.svg.selector)
    //     .select("svg")
    //     .remove();

    //   function save(dataBlob, filesize) {
    //     FileSaver.saveAs(dataBlob, filename); // FileSaver.js function
    //   }
    //   this.renderComponent = false;

    //   this.$nextTick(() => {
    //     // Add the component back in
    //     this.renderComponent = true;
    //   });
    // }
  }
};
</script>

<style lang='scss' >
/* Style the lines by removing the fill and applying a stroke */
.d3-stock-line {
  fill: none;
  stroke: #488aff;
  stroke-width: 3;
  stroke-opacity: 0.7;
}

#stockchartimg {
  position: fixed;
}

#stockchartimg > svg {
  visibility: hidden;
}

.tick {
  font-size: 11.5px;
  color: $color-secondary-text;
}

@media screen and (max-width: 420px) {
  .tick {
    font-size: 10px;
  }
}

.domain {
  stroke: none;
}

div.tooltipChart {
  font-family: DBHeaventRez;
  position: absolute;
  text-align: center;
  border-radius: 5px;
  padding: 2px 5px 2px 5px;
  font: 12px;
  background: #76a8f3;
  border: 0px;
  pointer-events: none;
  opacity: 25%;
  color: #333333;
  height: 40px;
  width: 120px;
  line-height: 1.5;
  transform: rotate(360deg)
}

.stock-line-dot {
  fill: #488aff;
}

.overlay {
  fill: none;
  pointer-events: all;
}
</style>

<style lang='scss' scoped>
/* Style for modal */
.header {
  padding-top: 30px;
  font-size: 28px;
  font-weight: bold;
  color: $hard-grey;
  width: max-content;
}

#close-btn {
  text-align: right;
  color: #979797;
  font-size: 24px;
  padding-right: 0.5em;
  font-weight: lighter !important;
  height: 24px;
}

.btn-wrapper {
  width: 70%;
  margin-top: 20px;
  .btn {
    margin: 10px;
    display: inline-block;
    width: 70px;
    height: 70px;
    background-color: $light-grey;
    border-radius: 50%;
    color: $hard-grey;
    &:hover {
      background-color: $finno-orange;
      color: white;
    }
    .fa-icon {
      position: relative;
      font-size: 2.4em;
    }
  }
}

.footer {
  text-align: center;
  .footer-text {
    font-size: 16px;
    margin-top: 20px;
  }
  .sharing-input {
    border: 1.5px solid $finno-orange;
    width: 70%;
    margin-top: 20px;
    margin-bottom: 60px;
    padding: 10px;
    font-size: 16px;
    color: $hard-grey;
  }
}

// .button-group {
//   text-align: left;
// }

.modal-body {
  .modal-header-stock-chart {
    display: flex !important;
    justify-content: space-between;
    padding: 0 20px;
    // background-color: yellowgreen;
    .modal-h-left {
      .chart-title {
        font-family: DBHeaventRez;
        font-size: 15.4px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #333333;
        margin-top: 5px;
      }
    }
    .modal-h-right {
      .action-button {
        width: 104px;
        height: 34px;
        cursor: pointer;
        border-radius: 4px;
        // border: solid 0.6px #222222;
        text-align: center;
        // padding: 7px;
        padding: 7px 7px 7px 10px;
        margin-left: 10px;
        font-family: DBHeaventRez;
        font-size: 12px;
        display: flex;
        background-color: $color-line-grey;
        color: #444444;
        margin-top: 12px;
        i {
          margin-right: 5px;
          margin-top: 2px;
        }
      }
    }
  }
}
@media only screen and (orientation: portrait) {
  #modal-chart {
    position: absolute;

    transform-origin: bottom left;
    width: 87vh;
    height: 98vw;
    margin-top: -93vw;
    object-fit: cover;
    // background-color: yellowgreen;
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
  }
}
@media only screen and (orientation: landscape) {
  #modal-chart {
    // height: 100%;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
</style>